import { createAsyncThunk } from '@reduxjs/toolkit';
import UserContractApi from '@infrastructure/user-contract-api';
import { getErrorPayload } from '@application/common/helpers/api-helper';
import { addSuccessNotification } from '../common/notificationSlice';
export const createUserContractAsync = createAsyncThunk('userContract/create', async (contract, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await UserContractApi.createUserContract(contract);
        dispatch(addSuccessNotification('Internal contract added successfully.'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateUserContractAsync = createAsyncThunk('userContract/update', async (contract, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await UserContractApi.updateUserContract(contract);
        dispatch(addSuccessNotification('Internal contract updated successfully.'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getUserContractByIdAsync = createAsyncThunk('userContract/getById', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await UserContractApi.getUserContractById(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getUserContractsByFreelancerAsync = createAsyncThunk('userContract/getByFreelancer', async (freelancerId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await UserContractApi.getUserContractsByFreelancer(freelancerId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getMyUserContractsAsync = createAsyncThunk('userContract/getMine', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await UserContractApi.getMyUserContracts();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateUserContractAutoContractAsync = createAsyncThunk('userContract/generateAutoContract', async ({ freelancerId, contactStartDate, contactEndDate, contractAutoGeneratedType, internalDepartmentId }, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await UserContractApi.generateUserContractAutoContract(freelancerId, contactStartDate, contactEndDate, contractAutoGeneratedType, internalDepartmentId);
        return fulfillWithValue(response.data.contractHtml);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
